"use client"
import { useState, useEffect } from "react";
import { get } from "@/app/helpers"; // your API helper
import { useTheme } from "./theme-provider";
export default function useFetch(url, { page = 1, limit = 10, search="",year="" } = {}, deps = [], initialValue = []) {
    const {
        theme,
        toggleTheme,
        toggleHighlightLinks,
        highlightLinks,
        language,
        toggleLanguage,
    } = useTheme();
    const [data, setData] = useState(initialValue);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  const [totalPages, setTotalPages] = useState(1)
    const [totalItems, setTotalItems] = useState(0) 
    useEffect(() => {
        if (!url) {
            setData(initialValue);
            setLoading(false);
            setError(null);
            setTotalItems(0);
            setTotalPages(1);
            return;
        }
        
        let isMounted = true;
        setLoading(true);
        // build query string
        const query = `?page=${page}&limit=${limit}&query=${search}&year=${year}`;

        const apiUrl = `${url}${query}`;
        get(apiUrl)
            .then((res) => {
                if (isMounted) {
                    setData(res.data || []);
                      const totalCount = res?.count 
                setTotalItems(totalCount)
                
        
                setTotalPages(Math.ceil(totalCount / limit))
                    setError(null);
                }
            })
            .catch((err) => {
                if (isMounted) setError(err);
            })
            .finally(() => {
                if (isMounted) setLoading(false);
            });

        return () => {
            isMounted = false;
        };
    }, [url, page, limit, language, ...deps]); // refetch whenever page/limit/url/deps change

    return { data,totalPages, loading, error };
}
